import React from 'react'

import { Tour } from 'generated/mos/org/getty/audio'

import { Handle } from 'components/ui/draggable'
import { ImageWithFallback } from 'components/ui/image'
import { IconDragHandle } from 'components/ui/icons'

import { Media } from 'generated/mos/media'

import { space } from 'helpers/style';
import styled from 'styled';

import { tourSchema } from '../../schemas/tour'

const Card = styled.div<{ isDragging: boolean }>`
  display: block;
  ${({ isDragging, theme }) => (
    `
      border: ${isDragging ? `2px solid ${theme.color.primary}` : `1px solid ${theme.color.grayL90}`};
      ${isDragging ? 'box-shadow: 0 2px 4px 0 rgba(0,0,0,0.10);' : null}
    `
  )}
  border-radius: 5px;
  overflow: hidden;
  transition: box-shadow 200ms ease, border 200ms ease;
  &:hover {
    box-shadow: 0 2px 4px 0 rgba(0,0,0,0.10);
  }
`;

const Title = styled.h4`
  margin: 0;
  font-size: ${({ theme }) => theme.font.size.base};
  color: ${({ theme }) => theme.color.darkText};
  height: ${space(10)};
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
`;

const Body = styled.div<{ isDragging: boolean }>`
  flex-shrink: 0;
  height: ${space(25)};
  padding: ${space(3)} ${space(3)} ${space(1)};
  background-color: ${({ theme, isDragging }) => isDragging ? theme.color.primaryL90 : theme.color.white};
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

const HorizontalHandle = styled(Handle)`
  margin: 0 auto;
`;


const Image = styled(ImageWithFallback)`
  height: ${space(40)};
`;

const Icon = styled(IconDragHandle)`
  transform: rotate(-90deg);
`

const HorizontalDragHandle = () => (
  <HorizontalHandle>
    <Icon size="medium" />
  </HorizontalHandle>
)

type Props = {
  readonly tour: Tour.Entity;
  readonly draggableIndex: number | undefined;
  readonly isDragging: boolean;
  readonly hostName: string;
}

export const CategoryTourItem = ({ tour, draggableIndex, isDragging, hostName }: Props) => {
  const tourImage = tourSchema.imageRef.read(tour.imageRef) as Media.Ref
  const tourImageId = tourImage && tourImage.id

  const imagePath = tourImageId ? `${hostName}/images/${tourImageId}.jpg?s=crop&h=320&w=468` : ''

  return (
    <Card isDragging={isDragging}>
      <Image src={imagePath} />
      <Body isDragging={isDragging}>
        <Title>{tourSchema.name.read(tour.name)}</Title>
        {draggableIndex !== undefined && <HorizontalDragHandle />}
      </Body>
    </Card>
  )
}
